export const getColor = (type) => {
  if (type === "Sketch") return "#21f650";
  if (type === "POL") return "#C394FF";
};
